import { PhoneFormatter } from "../../utils/phone-formatter";
export type SearchKundResponseDto = {
    id: number;
    namn: string;
    personOrgnummer: string;
    telefon: string;
    kundnummer: string;
    mobil: string;
    epost: string;
    adress: string;
    adress2: string;
    postnummer: string;
    postort: string;
    fornamn: string;
    efternamn: string;
    kontaktpersonId: number;
};

export class KundListItem {
    telefon: string;
    get namn() {
        return this.model.namn;
    }

    get adress() {
        return this.model.adress ?? this.model.adress2;
    }

    get epost() {
        return this.model.epost;
    }

    get postadress() {
        return `${this.adress} ${this.model.postnummer} ${this.model.postort}`;
    }

    get personOrgnummer() {
        return this.model.personOrgnummer;
    }

    get kundnummer() {
        return this.model.kundnummer;
    }

    constructor(readonly model: SearchKundResponseDto) {
        this.telefon = PhoneFormatter.renderPhonePresentation([
            this.model.mobil,
            this.model.telefon
        ]);
    }
}
